.body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.loadMore {
  align-self: flex-start;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.error {
  color: var(--error-60, #b00020);
  font-size: 14px;
  margin-right: auto;
  align-self: center;
}
